import { useState, useEffect, useRef } from 'react'

const INITIAL_SIZE = { innerHeight: 0, innerWidth: 0, outerHeight: 0, outerWidth: 0 }

const getSize = () => ({
  innerHeight: window.innerHeight,
  innerWidth: window.innerWidth,
  outerHeight: window.outerHeight,
  outerWidth: window.outerWidth,
})

const useWindowSize = () => {
  const ticking = useRef(false)
  const [windowSize, setWindowSize] = useState(INITIAL_SIZE)

  useEffect(() => {
    setWindowSize(getSize())

    const handleResize = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(() => {
          setWindowSize(getSize())
          ticking.current = false
        })
        ticking.current = true
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowSize
}

export default useWindowSize
